import ORDER_BOOK_ABI from '../assets/orderBookAbi.json'

export { ORDER_BOOK_ABI }

// 从 .env 读取，未配置时用测试网默认值
export const ORDERBOOK_ADDRESS = process.env.REACT_APP_ORDERBOOK_ADDRESS || '0x0E679eef852dE5e7D250ecDd311e013B46608120'
export const USDT_TOKEN_ADDRESS = '0xB82Db19f90daA3F40F25f7aC71786E7268139b0E'
export const WMUD_ADDRESS = '0x82f9d23cB62Ec0016109B7C4b8dB34890FdBA0F0'

export const ORDERBOOK_API_BASE = process.env.REACT_APP_ORDERBOOK_API || 'order'

console.log('ORDERBOOK_API_BASE', ORDERBOOK_API_BASE)
console.log('ORDERBOOK_ADDRESS', ORDERBOOK_ADDRESS)

// Order types
export enum OrderType {
  BUY = 0,
  SELL = 1
}

// Order status (matches OrderBook.sol)
export enum OrderStatus {
  OPEN = 0, // Waiting for fills (no fill yet or partially filled)
  FILLED = 1,
  CANCELLED = 2
}

// Decimals
export const USDT_DECIMALS = 6
export const MUD_DECIMALS = 18
export const FEE_RATE_BASE = 1000

// Defaults
export const DEFAULT_PUBLIC_FEE_RATE = 1 // 0.1%
export const DEFAULT_PRIVATE_FEE_RATE = 10 // 1%
export const MIN_ORDER_VALUE_USDT = 10 // 10 USDT
/** 挂单价格相对当前价倍数限制（合约 maxPriceMultiplier）：买入价 >= 当前价/5，卖出价 <= 当前价×5 */
export const MAX_PRICE_MULTIPLIER = 5

/** AccessControl: DEFAULT_ADMIN_ROLE (bytes32(0)) */
export const DEFAULT_ADMIN_ROLE = '0x0000000000000000000000000000000000000000000000000000000000000000'
/** AccessControl: EXECUTOR_ROLE = keccak256("EXECUTOR_ROLE")，需在运行时用 ethers.utils.id("EXECUTOR_ROLE") 取得 */
export const EXECUTOR_ROLE_KEY = 'EXECUTOR_ROLE'
